import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import {
  PaymentGatewayService,
  LocalService,
} from '../../../core/services';
import OrderConfirmedTemplate from '../../common/subscription-confirmed/order-confirmed-template';
import DateTimeComponent from '../helpers/date-time-component';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Skeleton } from '@mui/material';
import * as gtUtil from "../../../core/utility";

const paymentGateway: PaymentGatewayService = new PaymentGatewayService();
const localService: LocalService = new LocalService();

// Currency symbol by ISO-4217 for the amount shown on the confirmation page.
const CURRENCY_SYMBOLS: Record<string, string> = {
  INR: '₹', USD: '$', CAD: 'CA$', EUR: '€', GBP: '£', AED: 'د.إ', KES: 'KSh', NPR: 'रू',
};
const orderCurrencySymbol = (o: any): string =>
  CURRENCY_SYMBOLS[String(o?.currency || 'INR').toUpperCase()] || '₹';

export const SubscriptionConfirmed = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const payment_id = searchParams.get('payment_id');
  const razorpay_subscription_id = searchParams.get('razorpay_subscription_id');
  const isSubscriptionPage = location.pathname.includes('/subscription/');
  const campaign_id = searchParams.get('campaign_id') || '0'
  const campaign_planId = searchParams.get('campaign_planId') || '0'
  const [loading, setLoading] = useState<boolean>(false);

  const [retryCount, setRetryCount] = useState<number>(0);
  const MAX_RETRY = 12;

  const failedStatuses = ['failed', 'error', 'errored', 'validation_failed', 'blocked', 'halted', 'cancelled', 'expired'];

  const [order, setOrderDetails] = useState({
    name: '',
    email: '',
    contact: '',
    order_id: '',
    status: '',
    payment_id: '',
    amount: '',
    currency: '',
    plan_start: '',
    plan_end: '',
    plan_type: '',
    plan_name: '',
    account_type: ''
  })

  async function getOrderDetails(payment_id: string | number, razorpay_subscription_id: string) {
    try {
      setLoading(true);
      const response: any = await paymentGateway.getOrderDetails(payment_id, razorpay_subscription_id);
      if (response.status === gtUtil.Constants.SUCCESS) {
        setOrderDetails({...order, ...response.data.rows[0]})
        setLoading(false);
        if (window.gtag) {
          window.gtag('event', 'purchase', {
            transaction_id: response.data.rows[0]?.order_id,
            affiliation: 'Purchase Confirmation',
            value: response.data.rows[0]?.amount,
            currency: 'INR',
            tax: (response.data.rows[0].amount - response.data.rows[0].net_amount),
            items: [response.data.rows[0]],
          });
        }
      }
      // NOTE: the second operand used to be a bare truthy constant
      // (`|| gtUtil.Constants.QUERY_CATCH_ERROR`), so this branch fired on EVERY
      // non-success response — including the normal "not captured yet" polls while
      // the payment is still being confirmed — showing a spurious "Something went
      // wrong" toast even though the subscription ultimately succeeds. Compare the
      // status on both sides so it only fires on a real route/query error.
      else if (response.status === gtUtil.Constants.ROUTE_CATCH_ERROR || response.status === gtUtil.Constants.QUERY_CATCH_ERROR) {
        localService.toastify('Something went wrong', 'error', 1000);
      }
      else {
        localService.toastify(response.info, 'info', 1000);
        // setAvailablePlan(null);
      }
    } catch (error) {
      console.error(`getSubsctiption Detail in Subscription Influencer :: ${JSON.stringify(error)}`);
    }
  }

  // useEffect(() => {
  //   if (razorpay_subscription_id) {
  //     getOrderDetails(payment_id || '', razorpay_subscription_id);
  //   } else if (payment_id) {
  //     getOrderDetails(payment_id, '');
  //   }
  //   // getSubscriptionDetail();
  // }, []);

  useEffect(() => {

    if (!payment_id && !razorpay_subscription_id) return;

    getOrderDetails(payment_id || '', razorpay_subscription_id || '');

    const interval = setInterval(() => {

      if (order.status === 'captured' || retryCount >= MAX_RETRY) {
        clearInterval(interval);
        return;
      }

      setRetryCount(prev => prev + 1);
      getOrderDetails(payment_id || '', razorpay_subscription_id || '');

    }, 4000);

    return () => clearInterval(interval);

  }, [order.status]);

  // function get_header_content(){
  //   try{
  //     if (['Brand', 'Agency', 'Advertiser'].includes(order?.account_type) && ['New Campaign', 'Republish Campaign', 'New Paid Campaign', 'New Barter Campaign', 'Upgrade Barter Proposal Limit'].includes(order?.plan_name)){
  //       switch (order?.plan_name){
  //         case 'New Campaign':
  //           return "Congratulations! You can now run the campaign on the platform"
  //         case 'New Paid Campaign':
  //           return "Congratulations! You can now run the campaign on the platform"
  //         case 'New Barter Campaign':
  //           return "Congratulations! You can now run the campaign on the platform"
  //         case 'Republish Campaign':
  //           return "Payment Received. You can now run the campaign with your shortlisted influencers"
  //         case 'Upgrade Barter Proposal Limit':
  //           return "Congratulations! You will able to view 50+ more proposals"
  //         default:
  //           return "Congratulations! You can now run the campaign on the platform"
  //       }
  //     }
  //     else if (['Brand', 'Advertiser'].includes(order?.account_type)){
  //       return "Your payment is successful. Now you can publish unlimited campaigns and use all the features."
  //     }else{
  //       return "Your payment is successful. Now you can limitlessly apply to campaigns and use all the features."
  //     }
  //   } catch (error) {
  //     console.error(`handle transaction confirmation heading content Error :: ${error}`);
  //   }
  // }

  function get_header_content(){
    try{

      if (order?.status !== 'captured') {
        return "";
      }

      if (['Brand', 'Agency', 'Advertiser'].includes(order?.account_type) && ['New Campaign', 'Republish Campaign', 'New Paid Campaign', 'New Barter Campaign', 'Upgrade Barter Proposal Limit'].includes(order?.plan_name)){
        switch (order?.plan_name){
          case 'New Campaign':
          case 'New Paid Campaign':
          case 'New Barter Campaign':
            return "Congratulations! You can now run the campaign on the platform"
          case 'Republish Campaign':
            return "Payment Received. You can now run the campaign with your shortlisted influencers"
          case 'Upgrade Barter Proposal Limit':
            return "Congratulations! You can now view 20 more proposals on your barter campaign"
          default:
            return "Congratulations! You can now run the campaign on the platform"
        }
      }
      // OLD: else if (['Brand', 'Advertiser'].includes(order?.account_type)){
      // An agency buys for its brands, so it gets the brand wording too (the
      // order's account is the agency's).
      else if (['Brand', 'Agency', 'Advertiser'].includes(order?.account_type)){
        return "Your payment is successful. Now you can publish unlimited campaigns and use all the features."
      }else{
        return "Your payment is successful. Now you can limitlessly apply to campaigns and use all the features."
      }

    } catch (error) {
      console.error(`handle transaction confirmation heading content Error :: ${error}`);
    }
  }

  function get_header_title(){
    try{
      if (['New Campaign', 'Republish Campaign', 'New Paid Campaign', 'New Barter Campaign'].includes(order?.plan_name)){
        return "Payment details:"
      }else{
        return "Your subscription details:"
      }
    } catch (error) {
      console.error(`handle transaction confirmation heading title Error :: ${error}`);
    }
  }

  const renderCustomerDetails = () => {
    return (
      <TableContainer component={Paper}>
        <Table aria-label="customer details table">
          <TableBody>
            <TableRow>
              <TableCell className="pr-2">Customer Name:</TableCell>
              <TableCell>{order.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">Customer Email:</TableCell>
              <TableCell>{order.email || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">Customer Phone:</TableCell>
              <TableCell>{order.contact || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">Order id:</TableCell>
              <TableCell>{order.order_id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">Status:</TableCell>
              <TableCell>
                {order.status === 'captured' ? 'Success' : (failedStatuses.includes(order.status) ? 'Failed' : 'Processing')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">RazorPay Payment ID:</TableCell>
              <TableCell>{order.payment_id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="pr-2">Total Price:</TableCell>
              <TableCell>{order.amount !== '' ? `${orderCurrencySymbol(order)}${order.amount}` : ''}</TableCell>
            </TableRow>
            {[null, ''].includes(campaign_id) && (
              <>
                <TableRow>
                  <TableCell className="pr-2">Plan start date:</TableCell>
                  <TableCell><DateTimeComponent dateTimeString={order.plan_start} /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="pr-2">Plan end date:</TableCell>
                  <TableCell><DateTimeComponent dateTimeString={order.plan_end} /></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="pr-2">Plan Type:</TableCell>
                  <TableCell>{order.plan_type}</TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <OrderConfirmedTemplate
      userType={order?.account_type}
      planName={order?.plan_name}
      campaignPlanId={campaign_planId}
      campaignId={campaign_id}
      isMobileConfirmed={isSubscriptionPage}
      status={order.status}
    >
      <span className="pb-3 d-block mt-4">{get_header_content()}</span>
      <strong>{get_header_title()}</strong>
      { loading 
        ? 
          <Skeleton height={40} /> 
        : 
          renderCustomerDetails()
      }
    </OrderConfirmedTemplate>
  )
}